<template>
  <div class="custom-classes-chooser-classes">
    <template v-if="classesList && classesList.length">
      <div class="header">
        <div class="head">
          <el-checkbox v-model="checkAll"
                       :indeterminate="isIndeterminate"
                       @change="handleCheckAllChange">选择全部（{{checkedLength}}/{{filterClassesList.length}}）</el-checkbox>
        </div>
        <div class="tail">
          <el-input v-model="keyword"
                    size="mini"
                    type="text"
                    clearable
                    placeholder="搜索..."></el-input>
        </div>
      </div>
      <AppScrollbar v-if="filterClassesList.length"
                    class="main">
        <div class="classes-list">
          <el-checkbox-group v-model="checkList"
                             @change="handleCheckedListChange">
            <ul>
              <li v-for="classes in filterClassesList"
                  :key="classes.id">
                <slot name="classes"
                      :classes="classes"
                      :label="classes.name">
                  <el-checkbox :label="classes.name">{{classes.name}}</el-checkbox>
                </slot>
              </li>
            </ul>
          </el-checkbox-group>
        </div>
      </AppScrollbar>
      <Hint v-else
            class="main">
        <span>没有匹配的班级</span>
      </Hint>
    </template>
    <template v-else>
      <Hint>
        <span>班级列表为空</span>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'CustomClassesChooserClasses',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    value: Array,
    classesList: Array
  },
  data () {
    return {
      keyword: '',
      checkAll: false,
      isIndeterminate: false,
      checkList: []
    }
  },
  computed: {
    checkedLength () {
      if (this.filterClassesList) {
        return this.filterClassesList.filter(classes => this.checkList.includes(classes.name)).length
      }
    },
    filterClassesList () {
      let classesList = this.classesList
      if (classesList) {
        let keyword = this.keyword
        if (keyword) {
          return classesList.filter(classes => classes.name.includes(keyword))
        } else {
          return classesList
        }
      }
    }
  },
  methods: {
    handleCheckAllChange (val) {
      if (val) {
        // 合并
        this.filterClassesList.map((item) => {
          if (!this.checkList.includes(item.name)) {
            this.checkList.push(item.name)
          }
        })
      } else {
        // 减去checkList中包含filterClassesList中的name
        this.filterClassesList.map(item => {
          let index = this.checkList.findIndex(name => name === item.name)
          if (index !== -1) {
            this.checkList.splice(index, 1)
          }
        })
      }
      this.isIndeterminate = false
    },
    handleCheckedListChange () {
      if (this.filterClassesList) {
        this.checkAll = this.checkedLength === this.filterClassesList.length
        this.isIndeterminate = !!(this.checkedLength && this.checkedLength < this.filterClassesList.length)
      } else {
        this.checkAll = false
        this.isIndeterminate = false
      }
    }
  },
  watch: {
    value: {
      handler: function (vals) {
        this.checkList = vals || []
        this.handleCheckedListChange(this.checkList)
      },
      immediate: true
    },
    keyword: {
      handler: function () {
        this.handleCheckedListChange(this.checkList)
      }
    },
    checkList: function (vals) {
      this.$emit('input', vals)
    }
  }
}
</script>

<style lang="scss">
.custom-classes-chooser-classes {
  display: flex;
  flex-direction: column;
  & > .header {
    flex: none;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > .head {
      .el-checkbox {
        .el-checkbox__input {
          top: 1px;
        }
        .el-checkbox__label {
          font-size: 12px;
        }
      }
    }
    & > .tail {
      position: relative;
      .el-input {
        position: absolute;
        right: 0;
        top: 50%;
        width: 140px;
        transform: translateY(-50%);
        .el-input__inner {
          height: 24px;
          line-height: 24px;
          border-radius: 20px;
        }
        .el-input__suffix {
          right: 2px;
          .el-input__icon {
            line-height: 24px;
          }
        }
      }
    }
  }
  & > .main {
    flex: auto;
    .classes-list {
      padding: 5px 10px;
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        & > li {
          padding: 0 5px 10px 5px;
          min-width: 150px;
          .el-checkbox {
            .el-checkbox__input {
              top: 1px;
            }
            .el-checkbox__label {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .layout-hint {
    width: 100%;
  }
}
</style>
